const APTOS_MAINNET_NETWORK = {
  networkType: "aptos",
  tokens: [
    {
      symbol: "APT",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/APT.svg",
    },
    {
      symbol: "USDC",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDC.svg",
      contractAddress: "0xbae207659db88bea0cbead6da0ed00aac12edcdda169e591cd41c94180b46f3b",
    },
    {
      symbol: "USDT",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDT.svg",
      contractAddress: "0x357b0b74bc833e95a115ad22604854d6b0fca151cecd94111770e5d6ffc9dc2b",
    },
  ],
  supportedBrokerTypes: [
    "coinbase",
    "binanceUs",
    "binanceInternational",
    "okx",
    "huobi",
    "krakenDirect",
    "binanceInternationalDirect",
    "bitfinexDirect",
    "bybit",
    "coinbasePrime",
    "btcTurkDirect",
    "binanceConnect",
    "bybitDirect",
    "paribuOAuth",
    "coinbaseRamp",
    "sandbox",
    "sandboxCoinbase",
  ],
  addressPattern: "^0x[a-fA-F0-9]{2,64}$",
  supportedTokens: ["APT", "USDC", "USDT"],
  nativeSymbol: "APT",
  id: "c6427cfd-8ddf-44f1-b400-bc4a5ee190a3",
  name: "Aptos",
  logoUrl: "https://file-cdn.meshconnect.com/public/logos/networks/Aptos.svg",
};

const SEPOLIA_NETWORK = {
  networkType: "evm",
  tokens: [
    {
      symbol: "PYUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/PYUSD.svg",
      contractAddress: "0xCaC524BcA292aaade2DF8A05cC58F0a65B1B3bB9",
    },
    {
      symbol: "SEPOLIAETH",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/ETH.svg",
    },
    {
      symbol: "USDG",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDG.svg",
      contractAddress: "0xfBb2A78CceEb415b00300925e464C3E44E6e06b0",
    },
  ],
  supportedBrokerTypes: [],
  addressPattern: "^0x[a-fA-F0-9]{40}$",
  supportedTokens: ["PYUSD", "SEPOLIAETH", "USDG"],
  nativeSymbol: "SEPOLIAETH",
  id: "03b2d786-7092-4a6a-9737-d6013e21819b",
  name: "Sepolia",
  chainId: "11155111",
  logoUrl: "https://file-cdn.meshconnect.com/public/logos/networks/Ethereum.svg",
};

const SOLANA_DEVNET_NETWORK = {
  networkType: "solana",
  tokens: [
    {
      symbol: "DEVNETSOL",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/SOL.svg",
    },
    {
      symbol: "PYUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/PYUSD.svg",
      contractAddress: "CXk2AMBfi3TwaEL2468s6zP8xq9NxTXjp9gjMgzeUynM",
    },
    {
      symbol: "USDG",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDG.svg",
      contractAddress: "4F6PM96JJxngmHnZLBh9n58RH4aTVNWvDs2nuwrT5BP7",
    },
  ],
  supportedBrokerTypes: [],
  addressPattern: "^[1-9A-HJ-NP-Za-km-z]{32,44}",
  supportedTokens: ["DEVNETSOL", "PYUSD", "USDG"],
  nativeSymbol: "DEVNETSOL",
  id: "b7387cd9-2f47-4e4d-bc7b-d44e61d58210",
  name: "SolanaDevnet",
  chainId: "103",
  logoUrl: "https://file-cdn.meshconnect.com/public/logos/networks/Solana.svg",
};

const SOLANA_MAINNET_NETWORK = {
  networkType: "solana",
  tokens: [
    {
      symbol: "CASH",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/CASH.svg",
      contractAddress: "CASHx9KJUStyftLFWGvEVf59SGeG9sh5FfcnZMVPCASH",
    },
    {
      symbol: "EURC",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/EURC.svg",
      contractAddress: "HzwqbKZw8HxMN6bF2yFZNrht3c2iXXzpKcFu7uBEDKtr",
    },
    {
      symbol: "FARTCOIN",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/FARTCOIN.svg",
      contractAddress: "9BB6NFEcjBCtnNLFko2FqVQBq8HHM13kCyYcdQbgpump",
    },
    {
      symbol: "FDUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/FDUSD.svg",
      contractAddress: "9zNQRsGLjNKwCUU5Gq5LR8beUCPzQMVMqKAi3SSZh54u",
    },
    {
      symbol: "PENGU",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/PENGU.svg",
      contractAddress: "2zMMhcVQEXDtdE6vsFS7S7D5oUodfJHE8vd1gnBouauv",
    },
    {
      symbol: "PYUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/PYUSD.svg",
      contractAddress: "2b1kV6DkPAnxd5ixfnxCpjxmKwqjjaYmCZfHsFu24GXo",
    },
    {
      symbol: "SOL",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/SOL.svg",
    },
    {
      symbol: "TRUMP",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/TRUMP.svg",
      contractAddress: "6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN",
    },
    {
      symbol: "USDC",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDC.svg",
      contractAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
    },
    {
      symbol: "USDG",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDG.svg",
      contractAddress: "2u1tszSeqZ3qBWF3uNGPFc8TzMk2tdiwknnRMWGWjGWH",
    },
    {
      symbol: "USDT",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDT.svg",
      contractAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
    },
    {
      symbol: "WIF",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/WIF.svg",
      contractAddress: "EKpQGSJtjMFqKZ9KQanSqYXRcF8fBopzLHYxdM65zcjm",
    },
  ],
  supportedBrokerTypes: [
    "robinhood",
    "coinbase",
    "binanceUs",
    "binanceInternational",
    "okx",
    "huobi",
    "krakenDirect",
    "binanceInternationalDirect",
    "bitfinexDirect",
    "bybit",
    "paxos",
    "coinbasePrime",
    "btcTurkDirect",
    "binanceConnect",
    "revolutConnect",
    "bybitDirect",
    "paribuOAuth",
    "coinbaseRamp",
    "sandbox",
    "cryptoComPay",
    "uphold",
    "sandboxCoinbase",
  ],
  addressPattern: "^[1-9A-HJ-NP-Za-km-z]{32,44}",
  supportedTokens: [
    "CASH",
    "EURC",
    "FARTCOIN",
    "FDUSD",
    "PENGU",
    "PYUSD",
    "SOL",
    "TRUMP",
    "USDC",
    "USDG",
    "USDT",
    "WIF",
  ],
  nativeSymbol: "SOL",
  id: "0291810a-5947-424d-9a59-e88bb33e999d",
  name: "Solana",
  chainId: "101",
  logoUrl: "https://file-cdn.meshconnect.com/public/logos/networks/Solana.svg",
};

const ETHEREUM_MAINNET_NETWORK = {
  networkType: "evm",
  tokens: [
    {
      symbol: "AAVE",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/AAVE.svg",
      contractAddress: "0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9",
    },
    {
      symbol: "APE",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/APE.svg",
      contractAddress: "0x4d224452801ACEd8B2F0aebE155379bb5D594381",
    },
    {
      symbol: "ARB",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/ARB.svg",
      contractAddress: "0xB50721BCf8d664c30412Cfbc6cf7a15145234ad1",
    },
    {
      symbol: "BLUR",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/BLUR.svg",
      contractAddress: "0x5283D291DBCF85356A21bA090E6db59121208b44",
    },
    {
      symbol: "BUSD",
      contractAddress: "0x4Fabb145d64652a948d72533023f6E7A623C7C53",
    },
    {
      symbol: "CAKE",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/CAKE.svg",
      contractAddress: "0x152649eA73beAb28c5b49B26eb48f7EAD6d4c898",
    },
    {
      symbol: "CRO",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/CRO.svg",
      contractAddress: "0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b",
    },
    {
      symbol: "DAI",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/DAI.svg",
      contractAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    },
    {
      symbol: "DEXE",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/DEXE.svg",
      contractAddress: "0xde4EE8057785A7e8e800Db58F9784845A5C2Cbd6",
    },
    {
      symbol: "ENA",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/ENA.svg",
      contractAddress: "0x57e114B691Db790C35207b2e685D4A43181e6061",
    },
    {
      symbol: "ETH",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/ETH.svg",
    },
    {
      symbol: "EURC",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/EURC.svg",
      contractAddress: "0x1abaea1f7c830bd89acc67ec4af516284b1bc33c",
    },
    {
      symbol: "FDUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/FDUSD.svg",
      contractAddress: "0xc5f0f7b66764F6ec8C8Dff7BA683102295E16409",
    },
    {
      symbol: "FTM",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/FTM.svg",
      contractAddress: "0x4E15361FD6b4BB609Fa63C81A2be19d873717870",
    },
    {
      symbol: "GRT",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/GRT.svg",
      contractAddress: "0xc944E90C64B2c07662A292be6244BDf05Cda44a7",
    },
    {
      symbol: "IMX",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/IMX.svg",
      contractAddress: "0xF57e7e7C23978C3cAEC3C3548E3D615c346e79fF",
    },
    {
      symbol: "INJ",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/INJ.svg",
      contractAddress: "0xe28b3B32B6c345A34Ff64674606124Dd5Aceca30",
    },
    {
      symbol: "LDO",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/LDO.svg",
      contractAddress: "0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32",
    },
    {
      symbol: "LEO",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/LEO.svg",
      contractAddress: "0x2AF5D2aD76741191D15Dfe7bF6aC92d4Bd912Ca3",
    },
    {
      symbol: "LINK",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/LINK.svg",
      contractAddress: "0x514910771AF9Ca656af840dff83E8264EcF986CA",
    },
    {
      symbol: "MANA",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/MANA.svg",
      contractAddress: "0x0F5D2fB29fb7d3CFeE444a200298f468908cC942",
    },
    {
      symbol: "MKR",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/MKR.svg",
      contractAddress: "0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2",
    },
    {
      symbol: "MNT",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/MNT.svg",
      contractAddress: "0x3c3a81e81dc49A522A592e7622A7E711c06bf354",
    },
    {
      symbol: "PAXG",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/PAXG.svg",
      contractAddress: "0x45804880De22913dAFE09f4980848ECE6EcbAf78",
    },
    {
      symbol: "PYUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/PYUSD.svg",
      contractAddress: "0x6c3ea9036406852006290770BEdFcAbA0e23A0e8",
    },
    {
      symbol: "QNT",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/QNT.svg",
      contractAddress: "0x4a220E6096B25EADb88358cb44068A3248254675",
    },
    {
      symbol: "RLUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/RLUSD.svg",
      contractAddress: "0x8292Bb45bf1Ee4d140127049757C2E0fF06317eD",
    },
    {
      symbol: "RNDR",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/RNDR.svg",
      contractAddress: "0x6De037ef9aD2725EB40118Bb1702EBb27e4Aeb24",
    },
    {
      symbol: "SAND",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/SAND.svg",
      contractAddress: "0x3845badAde8e6dFF049820680d1F14bD3903a5d0",
    },
    {
      symbol: "SHIB",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/SHIB.svg",
      contractAddress: "0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE",
    },
    {
      symbol: "SNX",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/SNX.svg",
      contractAddress: "0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F",
    },
    {
      symbol: "TUSD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/TUSD.svg",
      contractAddress: "0x0000000000085d4780B73119b644AE5ecd22b376",
    },
    {
      symbol: "UNI",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/UNI.svg",
      contractAddress: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    },
    {
      symbol: "USD1",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USD1.svg",
      contractAddress: "0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d",
    },
    {
      symbol: "USDC",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDC.svg",
      contractAddress: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    },
    {
      symbol: "USDD",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDD.svg",
      contractAddress: "0x0C10bF8FcB7Bf5412187A595ab97a3609160b5c6",
    },
    {
      symbol: "USDG",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDG.svg",
      contractAddress: "0xe343167631d89B6Ffc58B88d6b7fB0228795491D",
    },
    {
      symbol: "USDP",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDP.svg",
      contractAddress: "0x8E870D67F660D95d5be530380D0eC0bd388289E1",
    },
    {
      symbol: "USDT",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/USDT.svg",
      contractAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    },
    {
      symbol: "VIRTUAL",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/VIRTUAL.svg",
      contractAddress: "0x44ff8620b8cA30902395A7bD3F2407e1A091BF73",
    },
    {
      symbol: "WBTC",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/WBTC.svg",
      contractAddress: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    },
    {
      symbol: "WETH",
      logoUrl: "https://file-cdn.meshconnect.com/public/logos/tokens/WETH.svg",
      contractAddress: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    },
    {
      symbol: "WLFI",
      contractAddress: "0xdA5e1988097297dCdc1f90D4dFE7909e847CBeF6",
    },
  ],
  supportedBrokerTypes: [
    "robinhood",
    "coinbase",
    "binanceUs",
    "binanceInternational",
    "okx",
    "huobi",
    "krakenDirect",
    "binanceInternationalDirect",
    "bitfinexDirect",
    "bybit",
    "paxos",
    "coinbasePrime",
    "btcTurkDirect",
    "paribuDirect",
    "binanceConnect",
    "revolutConnect",
    "bybitDirect",
    "paribuOAuth",
    "payPalConnect",
    "coinbaseRamp",
    "sandbox",
    "cryptoComPay",
    "uphold",
    "sandboxCoinbase",
    "bybitPay",
  ],
  addressPattern: "^0x[a-fA-F0-9]{40}$",
  supportedTokens: [
    "AAVE",
    "APE",
    "ARB",
    "BLUR",
    "BUSD",
    "CAKE",
    "CRO",
    "DAI",
    "DEXE",
    "ENA",
    "ETH",
    "EURC",
    "FDUSD",
    "FTM",
    "GRT",
    "IMX",
    "INJ",
    "LDO",
    "LEO",
    "LINK",
    "MANA",
    "MKR",
    "MNT",
    "PAXG",
    "PYUSD",
    "QNT",
    "RLUSD",
    "RNDR",
    "SAND",
    "SHIB",
    "SNX",
    "TUSD",
    "UNI",
    "USD1",
    "USDC",
    "USDD",
    "USDG",
    "USDP",
    "USDT",
    "VIRTUAL",
    "WBTC",
    "WETH",
    "WLFI",
  ],
  nativeSymbol: "ETH",
  id: "e3c7fdd8-b1fc-4e51-85ae-bb276e075611",
  name: "Ethereum",
  chainId: "1",
  logoUrl: "https://file-cdn.meshconnect.com/public/logos/networks/Ethereum.svg",
};

export const MESH_NETWORKS = {
  APTOS_MAINNET: APTOS_MAINNET_NETWORK,
  SEPOLIA: SEPOLIA_NETWORK,
  SOLANA_DEVNET: SOLANA_DEVNET_NETWORK,
  ETHEREUM_MAINNET: ETHEREUM_MAINNET_NETWORK,
  SOLANA_MAINNET: SOLANA_MAINNET_NETWORK,
};

export const SUPPORTED_TOKENS = {
  APTOS_MAINNET: "USDC",
  ETHEREUM_MAINNET: "USDC",
  SOLANA_MAINNET: "USDC",
  SEPOLIA: "PYUSD",
  SOLANA_DEVNET: "USDG",
};

export const MESH_INTEGRATION_ID = {
  COINBASE_SANDBOX: "721a5035-029f-4e05-bf3c-009da2fe381b",
  COINBASE: "47624467-e52e-4938-a41a-7926b6c27acf",
  BINANCE_CONNECT: "5620bf49-3240-4f85-8b4f-9dd6261597e2",
  BINANCE_INTERNATIONAL_DIRECT: "9226e5c2-ebc3-4fdd-94f6-ed52cdce1420",
};

// `type` values must match what Mesh returns in IntegrationAccessToken.brokerType and
// what the server forwards as `type` (see typescript/server/src/handlers/mesh.handler.ts
// INTEGRATION_ID_TO_BROKER_TYPE). Keep the two maps aligned when adding brokers.
export const INTEGRATION_ID_TO_BROKER = {
  [MESH_INTEGRATION_ID.COINBASE_SANDBOX]: { type: "coinbase", name: "Coinbase" },
  [MESH_INTEGRATION_ID.COINBASE]: { type: "coinbase", name: "Coinbase" },
  [MESH_INTEGRATION_ID.BINANCE_CONNECT]: { type: "binanceConnect", name: "Binance" },
  [MESH_INTEGRATION_ID.BINANCE_INTERNATIONAL_DIRECT]: {
    type: "binanceInternationalDirect",
    name: "Binance",
  },
} as const satisfies Record<string, { type: string; name: string }>;

export function resolveBrokerName(integrationId: string | undefined, fallback = "unknown"): string {
  if (!integrationId) return fallback;
  return INTEGRATION_ID_TO_BROKER[integrationId]?.name ?? fallback;
}

export const APTOS_MESH_NETWORK_ID = APTOS_MAINNET_NETWORK.id;
